import { type BarDataSet, type StackedBarDataSet } from 'app/components/chart/types';
import { useGetApplication } from 'app/hooks';
import httpApiApplication from 'app/http/httpApiApplication';
import queryString from 'query-string';
import { buildParams } from 'utils/params';

const baseUrl = '/managementreport';

export const useGetTaxpayerByCountryReport = (ignoreDefaultLang = false) => {
  const result = useGetApplication<BarDataSet>({
    url: `${baseUrl}/taxpayerByCountry`,
    params: undefined,
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
  return result;
};
export const getTaxpayerByCountryReport = async (params: any, ignoreDefaultLang = false) => {
  const newParams = buildParams(params);
  const queryParams = newParams ? `?${queryString.stringify(newParams)}` : '';
  return await httpApiApplication.get<BarDataSet>(`${baseUrl}/taxpayerByCountry${queryParams}`, {
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
};

export const useGetTaxpayerByOperationReport = (ignoreDefaultLang = false) => {
  const result = useGetApplication<BarDataSet>({
    url: `${baseUrl}/taxpayerByOperation`,
    params: undefined,
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
  return result;
};
export const getTaxpayerByOperationReport = async (params: any, ignoreDefaultLang = false) => {
  const newParams = buildParams(params);
  const queryParams = newParams ? `?${queryString.stringify(newParams)}` : '';
  return await httpApiApplication.get<BarDataSet>(`${baseUrl}/taxpayerByOperation${queryParams}`, {
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
};

export const useGetTaxpayerAmountReport = (ignoreDefaultLang = false) => {
  const result = useGetApplication<BarDataSet>({
    url: `${baseUrl}/taxpayerAmount`,
    params: undefined,
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
  return result;
};

export const getTaxpayerAmountReport = async (params: any, ignoreDefaultLang = false) => {
  const newParams = buildParams(params);
  const queryParams = newParams ? `?${queryString.stringify(newParams)}` : '';
  return await httpApiApplication.get<BarDataSet>(`${baseUrl}/taxpayerAmount${queryParams}`, {
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
};

export const getTaxByCountryReport = async (params: any, ignoreDefaultLang = false) => {
  const newParams = buildParams(params);
  const queryParams = newParams ? `?${queryString.stringify(newParams)}` : '';
  return await httpApiApplication.get<StackedBarDataSet>(`${baseUrl}/taxByCountry${queryParams}`, {
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
};

export const getTaxByTaxReport = async (params: any, ignoreDefaultLang = false) => {
  const newParams = buildParams(params);
  const queryParams = newParams ? `?${queryString.stringify(newParams)}` : '';
  return await httpApiApplication.get<StackedBarDataSet>(`${baseUrl}/taxByTax${queryParams}`, {
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
};

//payment

export const getPaymentByCountryReport = async (params: any, ignoreDefaultLang = false) => {
  const newParams = buildParams(params);
  const queryParams = newParams ? `?${queryString.stringify(newParams)}` : '';
  return await httpApiApplication.get<StackedBarDataSet>(
    `${baseUrl}/paymentByCountry${queryParams}`,
    {
      headers: ignoreDefaultLang ? { lang: true } : undefined
    }
  );
};

export const getPaymentByTaxReport = async (params: any, ignoreDefaultLang = false) => {
  const newParams = buildParams(params);
  const queryParams = newParams ? `?${queryString.stringify(newParams)}` : '';
  return await httpApiApplication.get<StackedBarDataSet>(`${baseUrl}/paymentByTax${queryParams}`, {
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
};
